import type { ReactNode } from 'react';
import { EcregiSeal } from '@/components/ui/ecregi-seal';

export function AuthCard({
  children,
  footer,
  onBack,
}: {
  children: ReactNode;
  footer?: ReactNode;
  onBack?: () => void;
}) {
  return (
    <div className="mx-auto w-full max-w-md">
      <div className="relative rounded-2xl border border-gray-200 bg-white p-6 sm:p-8 shadow-card">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="absolute left-4 top-4 sm:left-6 sm:top-6 flex h-9 w-9 items-center justify-center rounded-full bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors border border-gray-200 shadow-xs"
            title="Back"
            aria-label="Back"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
          </button>
        ) : null}
        <div className="flex flex-col items-center">
          <EcregiSeal size={72} />
        </div>
        <div className="mt-6">{children}</div>
        {footer ? <div className="mt-8 text-center text-xs text-gray-500">{footer}</div> : null}
      </div>
    </div>
  );
}

export function TermsFooter() {
  /*
  return (
    <p>
      By continuing, you agree to our{' '}
      <a href="/terms" className="underline underline-offset-2">
        Terms
      </a>{' '}
      and{' '}
      <a href="/privacy" className="underline underline-offset-2">
        Privacy Policy
      </a>
      .
    </p>
  );
  */
  return null;
}
